<div class="pt-2 pb-3">
  <section class="mt-1 mb-3 rounded m-auto w-100" id="section">
    <form [formGroup]="callToActionEditform">

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'pass.name' | translate}}</mat-label>
        <input formControlName="name" type="text" matInput placeholder="{{'pass.name' | translate}}">
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'pass.iconAlignment' | translate}}</mat-label>
        <mat-select formControlName="iconAlignment" class="input-group">
          <mat-option value="left">{{'pass.left' | translate}}</mat-option>
          <mat-option value="center">{{'pass.center' | translate}}</mat-option>
          <mat-option value="right">{{'pass.right' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-card class="mb-4">
        <mat-card-content>
          <div class="p-2">
            @if (urlData || dynamicUrl) {
              <div>
                <div class="d-flex align-items-center mb-3">
                  <mat-icon class="material-symbols-outlined" >image</mat-icon>
                  <span class="px-2">{{'pass.widgets.img' | translate}}</span>
                </div>
                <div class="d-flex justify-content-stretch flex-column">
                  <div class="custom-form-field" >
                    <img [src]="urlData" style="width:100%; border-radius:5px;" onerror="this.src='./../../assets/img/default.jpg'" >
                  </div>
                  @if (!urlData) {
                    <div class="custom-form-field" [ngStyle]="{'background-image': 'url( ./../../assets/img/default.jpg)'}"></div>
                  }
                  <div class="form-fields mt-3">
                    <div class="d-flex align-items-center">
                      <mat-form-field appearance="outline" class="flex-grow-1">
                        <mat-label>{{ 'pass.url' | translate }}</mat-label>
                        <input type="text" formControlName="imageUrl" matInput (change)="checkNewUrl()">
                        <button mat-icon-button matSuffix (click)="deleteImg(url)" class="delete-button"
                          matTooltip="{{ 'pass.deleteIMG' | translate }}" [disabled]="translationModeOriginal">
                          <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        </button>
                        @if (callToActionEditform.controls['imageUrl']?.hasError('invalidCharacters')) {
                          <mat-error>
                            {{ 'invalid_characters' | translate }}
                          </mat-error>
                        }
                        @if (callToActionEditform.controls['imageUrl']?.hasError('pattern') && !callToActionEditform.controls['imageUrl']?.hasError('invalidCharacters')) {
                          <mat-error>
                            {{ 'url_pattern_invalid' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'pass.fallbackUrl' | translate}}</mat-label>
                    <input formControlName="fallbackUrl" type="text" matInput placeholder="{{'pass.fallbackUrl' | translate}}">
                    @if (callToActionEditform.controls['fallbackUrl']?.hasError('invalidCharacters')) {
                      <mat-error>
                        {{ 'invalid_characters' | translate }}
                      </mat-error>
                    }
                    @if (callToActionEditform.controls['fallbackUrl']?.hasError('pattern') && !callToActionEditform.controls['fallbackUrl']?.hasError('invalidCharacters')) {
                      <mat-error>
                        {{ 'url_pattern_invalid' | translate }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{'pass.altTitle' | translate}}</mat-label>
                  <input formControlName="altTitle" type="text" matInput placeholder="{{'pass.altTitle' | translate}}">
                </mat-form-field>
              </div>
            }
            @if (!hasAnyImage && !dynamicUrl) {
              <div>
                <div class="d-flex align-items-center mb-3">
                  <mat-icon class="material-symbols-outlined">image</mat-icon>
                  <span class="px-2">{{'pass.widgets.img' | translate}}</span>
                </div>
                <div [app-drag-file-browse-ui]="dragFileData" (returnChanges)="returnChangesDragFileBrowseUI($event)"></div>
              </div>
            }
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="p-3">
        <mat-card-content>
          <label for="hasLogin">{{'pass.callToAction.networks' | translate}}</label>
          <div class="mb-2">
            <button mat-button class="secondary-gray-button my-3" id="btn-add" [matMenuTriggerFor]="sm_links" [disabled]="translationModeOriginal || data.translateMode">
              <mat-icon>add_circle</mat-icon> {{'add' | translate}}
            </button>
          </div>
          <mat-menu #sm_links="matMenu">
            @for (sn of posibleNetworks; track sn) {
              <div  >
                <button mat-menu-item (click)="addNetwork(sn.name);" [disabled]="translationModeOriginal || data.translateMode || sn.added==true">
                  <span>
                                    <i class="bi bi-{{
                                        sn.name === 'twitter' 
                                        ? 'twitter-x' 
                                        : sn.name === 'whatsApp' 
                                            ? 'whatsapp' 
                                            : sn.name
                                    }} menu-sm-icon"></i>
                    {{sn.label}}
                  </span>
                </button>
              </div>
            }
          </mat-menu>
          @for (s of posibleNetworks; track s) {
            <div>
              @if (s.added) {
                <mat-form-field appearance="outline" class="w-100">
                  <i
                    matPrefix
                                class="bi bi-{{
                                    s.name === 'twitter' 
                                    ? 'twitter-x' 
                                    : s.name === 'whatsApp' 
                                        ? 'whatsapp' 
                                        : s.name
                                }}" 
                    style="font-size:20px; margin:15px;">
                  </i>
                  <mat-label >{{s.label}}</mat-label>
                  <input formControlName="{{s.name}}" id="{{s.name}}" type="text" matInput value="{{s.url}}" (change)="updateSocialNetwork(s.name)">
                  <button class="delete-button" style="vertical-align: middle;" mat-icon-button matTooltip="{{'pass.callToAction.remove_network' | translate}}" matSuffix (click)="removeNetwork(s.name);" [disabled]="translationModeOriginal">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                  </button>
                  @if (callToActionEditform.controls[s.name]?.hasError('invalidCharacters')) {
                    <mat-error>
                      {{ 'invalid_characters' | translate }}
                    </mat-error>
                  }
                  @if (callToActionEditform.controls[s.name]?.hasError('required')) {
                    <mat-error>
                      {{ 'required' | translate }}
                    </mat-error>
                  }
                  @if (callToActionEditform.controls[s.name]?.hasError('pattern') && !callToActionEditform.controls[s.name]?.hasError('invalidCharacters')) {
                    <mat-error>
                      {{ 'url_pattern_invalid' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              }
            </div>
          }

        </mat-card-content>
      </mat-card>

    </form>
  </section>
  <div [app-widget-edit-filters] = "{'form':callToActionEditform.value, 'widgetData': data}" (returnChanges)="returnChangesFilters($event)"></div>
</div>
